<template>
  <li>
    <router-link :to="{ name: 'Order', params: { id: id } }" href="index.html">
      <div>
        <div class="tit">貨號單名稱</div>
        <span>{{ orderId }}</span>
      </div>
      <div>
        <div class="tit">尺寸</div>
        <span>{{ size }}</span>
      </div>
      <div>
        <div class="tit">顏色</div>
        <span>{{ color }}</span>
      </div>
      <!-- <div>
        <div class="tit">日期</div>
        <span>{{ date }}</span>
      </div> -->
    </router-link>
  </li>
</template>
<script>
export default {
  name: "OrderListItem",
  props: ["id", "orderId", "size", "color"],
};
</script>